import { BasketAdvisorOrderEntity, BasketCustomerOrderEntity } from '@genial/services';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';

import { setupPDF } from '../../../../../Resume/utils';
import { batchTicketOrderResumePdfTemplate } from '../../../../utils';
import { normalizeBatchTicketInfo } from '../../../../utils/PdfTemplate/normalizer';
import { TotalSummaryItemDesktop } from '../../../Resume/components/TotalSummaryItem/desktop';
import { TotalSummaryItemMobile } from '../../../Resume/components/TotalSummaryItem/mobile';
import { TotalSummaryItemTablet } from '../../../Resume/components/TotalSummaryItem/tablet';

interface ItemProps {
  item: BasketCustomerOrderEntity;
  basketData: BasketAdvisorOrderEntity;
}

const handleExportNewOrder = (
  item: BasketCustomerOrderEntity,
  basketData: BasketAdvisorOrderEntity
) => {
  const orderHash = basketData.basketOrderHash || '';
  const pdfData = normalizeBatchTicketInfo(item, basketData);
  setupPDF(batchTicketOrderResumePdfTemplate(pdfData), `ordem-${orderHash}.pdf`);
};

export const Item: React.FC<ItemProps> = ({ item, basketData }) => {
  const allocatedBalanceFormatted = Utils.Mask.Money(
    item?.customer?.account?.allocatedBalance || 0
  );
  const allocatedBalancePercentageFormatted = Utils.Mask.Percentage(
    item?.customer?.account?.allocatedBalancePercentage || 0
  );

  const remainingBalanceFormatted = Utils.Mask.Money(
    item?.customer?.account?.remainingBalance || 0
  );

  const remainingBalancePercentageFormatted = Utils.Mask.Percentage(
    item?.customer?.account?.remainingBalancePercentage || 0
  );

  const allocatedBalanceField = `${allocatedBalanceFormatted} | ${allocatedBalancePercentageFormatted}`;
  const remainingBalanceField = `${remainingBalanceFormatted} | ${remainingBalancePercentageFormatted}`;

  const props = {
    item,
    handleExportItem: () => handleExportNewOrder(item, basketData),
    detailsBasketItemButtonIsDisabled: false,
    availableBalance: item.customer.account.availableBalance,
    allocatedBalanceField,
    remainingBalanceField,
  };

  const layout = useBreakpointValue({
    base: <TotalSummaryItemMobile {...props} />,
    sm: <TotalSummaryItemTablet {...props} />,
    lg: <TotalSummaryItemDesktop {...props} />,
  });

  return layout;
};
